export const ElectedPos = [
  {
    title: "Honor Council Representative",
    email: "joneshonorcouncilrep@gmail.com",
    people: ["Molly Chen"],
  },
  {
    title: "O-Week Coordinators",
    email: "jonescollegeoweek@gmail.com",
    people: ["Banesa Valencia", "Sawyer Rudy", "Iris Rivera"],
  },
  {
    title: "Social Coordinators",
    email: "jonessocials@gmail.com",
    people: ["Iris Rivera", "Poema Sumrow", "Andrei Jones", "Maxwell Hansen"],
  },
  {
    title: "U-Court Representative",
    email: "jonesucourt@gmail.com",
    people: ["Emma Qian"],
  },
];
